export const badRequestStatus = 400;
export const unauthorizedStatus = 401;
export const notFoundStatus = 404;
export const notAcceptableStatus = 406;
export const unprocessableEntity = 422;
export const okStatus = 200;
export const okNoContentStatus = 204;
export const forbiddenStatus = 403;
export const genericErrorStatus = 500;
export const serviceUnavailableStatus = 503;
